import { use } from 'react';
import { linesContext } from './lines-provider';

export const useLines = () => {
  const context = use(linesContext);

  if (!context) {
    throw new Error('useLines must be used within a LinesProvider');
  }

  return context;
};
